const appraisals = {
  review_your_first: {
    title: 'Review your first design',
    description:
      'Leverage AI to analyze a single page of your website or application',
  },
  design_reviews: 'Design reviews',
  design_review: 'Design review',
  design_review_accessibility: 'Review: WCAG: Level {{level}}',
  design_review_refactoringui: 'Review: Refactoring UI',
  review_a_page: 'Review a design',
  review: 'Review',
  screen_appraisals: 'Screen appraisals ({{count}})',
  show_all_appraisals: 'Show all ({{count}})',
  hide_all_appraisals: 'Hide all ({{count}})',
  no_appraisals: 'No appraisals were generated',
  appraisal_category: {
    accessibility: 'Accessibility',
    unknown: 'Other',
  },
  no_appraisals_generated: 'Looks great to us!',
  no_appraisals_generated_description: 'Design passes all our supported checks',
  generating_appraisals: 'Generating appraisals',
  appraisal_cautions_one: '{{count}} caution',
  appraisal_cautions_other: '{{count}} caution',
  appraisal_elements: '{{count}} elements',
  select_design_for_review: 'Select a design to review',
  select_design_from_canvas: 'Select a frame on the canvas',
  select_design_from_canvas_description: '2000x2000px maximum',
  selected_page: 'Selected frame',
  no_page_selected: 'No page selected',
  review_method: {
    title: 'What should we review?',
    accessibility: {
      title: 'Accessibility',
      description: 'Ensure inclusivity and enhance\noverall usability',
      wcag: 'WCAG',
    },
    refactoring_ui: {
      title: 'General UI',
      description:
        'Ensure interface is user-friendly,\nfunctional, and meets user needs',
    },
  },
  review_error: {
    you_must_select_page: 'You have to select a page to review',
    you_must_choose_method: 'You have to select the review method',
    unable_to_load_font:
      'This font used in your design isn’t installed on your computer. Please install it to enable design reviews.',
    unable_to_load_fonts:
      'These fonts used in your design aren’t installed on your computer. Please install them to enable design reviews.',
    missing_font: 'Missing font: {{name}}',
    missing_fonts: 'Missing fonts: {{name}}',
    unable_to_generate_reviews:
      'Something went wront while trying to generate appraisals',
    unable_to_analyze_image: "We couldn't review this design",
    unable_to_analyze_image_description:
      'This design pushed us beyond our existing config! We will investigate...',
    get_the_font_here: 'Get the {{name}} font',
  },
  level: {
    error: 'Flaw',
    warning: 'Warn',
    notice: 'Info',
  },
  image_error: {
    image_too_big:
      'Selected node is too big, maximum allowed height to width ratio is 10:1',
    unable_to_generate_image: 'Unable to load selected node',
    unable_to_find_node: 'Unable to load selected node',
  },
  delete: {
    title: 'Delete the appraisal',
    description: `You are about to delete the appraisal.
This action cannot be undone. Do you want to proceed?`,
  },
  powered_by: {
    uxcel: {
      title: 'Powered by Uxcel',
      description:
        "We are using data from Uxcel's Intro to accessibility course to review this design",
    },
    refactoringui: {
      title: 'Powered by Refactoring UI',
      description:
        'We are using the content of the "Refactoring UI" book to review this design',
    },
  },
  unable_to_render_text: '[Unable to display]',
  guest_notice: {
    title: 'Sign up to access all appraisals',
    text: 'Unlock full design review access for free',
    badge_one: '{{count}} appraisal hidden',
    badge_other: '{{count}} appraisal hidden',
    badge_more: 'More appraisals hidden',
  },
  card_text: 'Check layout, clarity, and accessibility',
  get_full_review: 'Get full review',
} as const;

export default appraisals;
